<template>
    <div class="card rounded-more p-3" :style="style" ref="skeletonCard">
        <content-loader :viewBox="viewBox" :width="width" :height="height" preserveAspectRatio="none">
            <rect x="0" y="0" rx="3" ry="3" width="170" height="25" />
            <rect x="90%" y="0" rx="3" ry="3" width="100" height="25" />
            <rect x="0" y="45%" rx="3" ry="3" width="250" height="80" />
            <rect x="91%" y="55%" rx="3" ry="3" width="80" height="60" />
        </content-loader>
    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
    name : 'SkeletonCurrentBonusCard',
    components : {
        ContentLoader
    },
    computed : {
        width : function(){
            if( this.$refs.skeletonCard ){
                return this.$refs.skeletonCard.getBoundingClientRect().width
            }
            
            return 1000
        },
        height : function(){
            return 220
        },
        viewBox : function(){
            return `0 0 ${this.width} ${this.height}`
        },
        style: function(){
            return `height:${this.height}px`
        }
    }
}
</script>